import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../core/services/api.service';
import { AppVersionPolicyModel, SaveAppVersionPolicyRequest } from '../models/app-version-policy.model';

@Injectable({
  providedIn: 'root'
})
export class AppVersionService {
  constructor(private apiService: ApiService) {}

  getPolicies(): Observable<AppVersionPolicyModel[]> {
    return this.apiService.get('AppVersion');
  }

  savePolicy(request: SaveAppVersionPolicyRequest): Observable<AppVersionPolicyModel> {
    return this.apiService.post('AppVersion/save', request);
  }
}
